import { Route, Switch, Redirect } from 'react-router-dom';
import asyncComponent from '../../itrust_common/components/AsyncComponent';




const StoreProfileSetting = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/storeProfile/StoreProfileSetting')
)
const ExamProcedurePricing = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/procedurePricing/ProcedurePricing')
)
const DefaultBillingProvider = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/providerDetails/DefaultBillingProvider')
)
const DefaultProvider = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/defaultProvider/DefaultProvider')
)
const ServiceProviderLocation = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/providerDetails/ServiceProviderLocation')
)
const PrescriptionExpiration = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/prescriptionExpiration/PrescriptionExpiration')
)
const MessageTracking = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/messageTracking/MessageTracking')
)
const StoreContact = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/storeContact/StoreContact')
)
const VisionWeb = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/visionWeb/VisionWeb')
)
const StorePromotion = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/promotions/StorePromotion')
)
const FramesData = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/framesData/FramesData')
)
const VisionWebLensType = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/visionWeb/mapping/LensTypeMapping')
)
const VisionWebLensMaterial = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/visionWeb/mapping/LensMaterialMapping')
)
const VisionWebFrames = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/visionWeb/mapping/FramesMapping')
)
const DesignsMapping = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/visionWeb/mapping/DesignsMapping')
)
const VisionWebAddOns = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/visionWeb/mapping/AddOnsMapping')
)
const DeviceIntegration = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/deviceIntegration/DeviceIntegration')
)
const PaymentMethods = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/paymentMethods/PaymentMethods')
)
const ManageStatus = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/manageStatus/ManageStatus')
)
const TaxSettings = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/taxSettings/TaxSettings')
)
const ITrustConnectDevice = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/iTrustConnectDevice/ITrustConnectDevice')
)
const StoreEyeglassLensType = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreEyeglassLensType')
)
const StoreEyeglassAddons = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreEyeglassAddons')
)
const StoreStockLenses = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreStockLenses')
)
const StoreEyeglassFrame = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreEyeglassFrame')
)
const StorePhysicalInventory = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StorePhysicalInventory')
)
const StoreReconcile = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreReconcile')
)
const StoreEyeglassLensMaterial = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreEyeglassLensMaterial')
)
const StoreMiscItems = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreMiscItems')
)
const StoreContactLens = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/contactLens/StoreContactLens')
)
const StoreCleaningSolution = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/orderSettings/contactLens/StoreCleaningSolution')
)
const StoreCalendarSetting = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/calendarSettings/StoreCalendarSetting')
)
const StoreAnonymousSetting = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/calendarSettings/StoreAnonymousSetting')
)
const StaffAuthControl = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/staffAuth/StaffAuthControl')
)
const StoreVisionInsurance = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/insuranceSetting/StoreVisionInsurance')
)
const StoreMedicalInsurance = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/insuranceSetting/StoreMedicalInsurance')
)
const StoreVisionInsurancePlans = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/insuranceSetting/StoreVisionInsurancePlans')
)
const StoreMedicalInsurancePlans = asyncComponent(() =>
  import('../../containers/authorised/storeSettings/insuranceSetting/StoreMedicalInsurancePlans')
)


const OrganisationStoreRoutes = (
  <Switch>
    {/* store office settings */}
    <Route exact path="/organisation/stores/:id/settings/store/store-setting" component={StoreProfileSetting} />
    <Route exact path="/organisation/stores/:id/settings/store/exam-procedure-pricing" component={ExamProcedurePricing} />
    <Route exact path="/organisation/stores/:id/settings/store/default-billing-provider" component={DefaultBillingProvider} />
    <Route exact path="/organisation/stores/:id/settings/store/default-provider" component={DefaultProvider} />
    <Route exact path="/organisation/stores/:id/settings/store/service-provider-location" component={ServiceProviderLocation} />
    <Route exact path="/organisation/stores/:id/settings/store/prescription-expiration" component={PrescriptionExpiration} />
    <Route exact path="/organisation/stores/:id/settings/store/device-integration" component={DeviceIntegration} />
    <Route exact path="/organisation/stores/:id/settings/store/payment-methods" component={PaymentMethods} />
    <Route exact path="/organisation/stores/:id/settings/store/manage-status" component={ManageStatus} />
    <Route exact path="/organisation/stores/:id/settings/store/tax-settings" component={TaxSettings} />
    <Route exact path="/organisation/stores/:id/settings/store/itrust-connect-device" component={ITrustConnectDevice} />
    <Route exact path="/organisation/stores/:id/settings/store/staffs-auth" component={StaffAuthControl} />
    <Route exact path="/organisation/stores/:id/settings/message-tracking-number" component={MessageTracking} />
    <Route exact path="/organisation/stores/:id/settings/contact" component={StoreContact} />
    <Route exact path="/organisation/stores/:id/settings/vision-web" component={VisionWeb} />
    <Route exact path="/organisation/stores/:id/settings/promotion" component={StorePromotion} />
    <Route exact path="/organisation/stores/:id/settings/frames-data" component={FramesData} />
    <Route exact path="/organisation/stores/:id/settings/vision-web/mapping/lens-type" component={VisionWebLensType} />
    <Route exact path="/organisation/stores/:id/settings/vision-web/mapping/lens-material" component={VisionWebLensMaterial} />
    <Route exact path="/organisation/stores/:id/settings/vision-web/mapping/designs" component={DesignsMapping} />
    <Route exact path="/organisation/stores/:id/settings/vision-web/mapping/frames" component={VisionWebFrames} />
    <Route exact path="/organisation/stores/:id/settings/vision-web/mapping/add-ons" component={VisionWebAddOns} />
    <Redirect exact from="/organisation/stores/:id/settings/integrations" to="/organisation/stores/:id/settings/vision-web" />
    <Redirect exact from="/organisation/stores/:id/settings/vision-web/mapping" to="/organisation/stores/:id/settings/vision-web/mapping/lens-type" />
    <Route exact path="/organisation/stores/:id/settings/calendar/calendar-setting" component={StoreCalendarSetting} />
    <Route exact path="/organisation/stores/:id/settings/calendar/anonymous-booking" component={StoreAnonymousSetting} />
    <Route exact path="/organisation/stores/:id/settings/insurance/vision-insurance" component={StoreVisionInsurance} />
    <Route exact path="/organisation/stores/:id/settings/insurance/medical-insurance" component={StoreMedicalInsurance} />
    <Route exact path="/organisation/stores/:id/settings/insurance/vision-insurance/plans" component={StoreVisionInsurancePlans} />
    <Route exact path="/organisation/stores/:id/settings/insurance/medical-insurance/plans" component={StoreMedicalInsurancePlans} />
    <Redirect exact from="/organisation/stores/:id/settings/calendar" to="/organisation/stores/:id/settings/calendar/calendar-setting" />
    <Redirect exact from="/organisation/stores/:id/settings/order-settings" to="/organisation/stores/:id/settings/store/payment-methods" />
    <Redirect exact from="/organisation/stores/:id/settings/insurance" to="/organisation/stores/:id/settings/insurance/vision-insurance" />
    <Redirect exact from="/organisation/stores/:id/settings/insurance/default-billing-provider" to="/organisation/stores/:id/settings/store/default-billing-provider" />
    <Redirect exact from="/organisation/stores/:id/settings/insurance/service-provider-location" to="/organisation/stores/:id/settings/store/service-provider-location" />
    <Redirect exact from="/organisation/stores/:id/settings/store" to="/organisation/stores/:id/settings/store/store-setting" />
    <Redirect exact from="/organisation/stores/:id" to="/organisation/stores/:id/settings/store/store-setting" />
    {/* order-inventory routes */}
    <Route exact path="/organisation/stores/:id/settings/order-inventory/eyeglass" component={StoreEyeglassLensType} />
    <Route exact path="/organisation/stores/:id/settings/order-inventory/eyeglass/lens-material" component={StoreEyeglassLensMaterial} />
    <Route exact path="/organisation/stores/:id/settings/order-inventory/eyeglass/frame" component={StoreEyeglassFrame} />
    <Route exact path="/organisation/stores/:id/settings/order-inventory/eyeglass/physical-inventory" component={StorePhysicalInventory} />
    <Route exact path="/organisation/stores/:id/settings/order-inventory/eyeglass/reconcile" component={StoreReconcile} />
    <Route exact path="/organisation/stores/:id/settings/order-inventory/eyeglass/add-ons" component={StoreEyeglassAddons} />
    <Route exact path="/organisation/stores/:id/settings/order-inventory/eyeglass/stock-lenses" component={StoreStockLenses} />
    <Route exact path="/organisation/stores/:id/settings/order-inventory/misc" component={StoreMiscItems} />
    {/* contact lens */}
    <Route exact path="/organisation/stores/:id/settings/order-inventory/contact-lens" component={StoreContactLens} />
    <Route exact path="/organisation/stores/:id/settings/order-inventory/contact-lens/cleaning-solution" component={StoreCleaningSolution} />

  </Switch>
);


export default OrganisationStoreRoutes;
